/** @format */

import styled from 'styled-components';

export const ShowMoreButton = styled.button`
  margin-block: 1.25rem 0;
  max-width: fit-content;
  flex-shrink: 0;
  --accent-color: ${({ theme }) => theme.colors.joivy['teal-dark']};
  text-decoration: none;
  padding: 0.5rem 1rem;
  color: ${({ theme }) => theme.colors.joivy.white};
  background-color: var(--accent-color);
  border: 1px solid var(--accent-color);
  border-radius: 2.25rem;
  text-decoration: none;
  font-size: 0.9375rem;
  font-weight: 600;
  letter-spacing: clamp(0.03rem, 0.0287rem + 0.0056vw, 0.03375rem);
  cursor: pointer;
  transition: all 0.5s cubic-bezier(0.36, 0.33, 0, 1) 0s;
  &:hover {
    --accent-color: ${({ theme }) => theme.colors.joivy['teal-light']};
  }
`;
export const Colivers = styled.div`
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 1.5rem 0;
`;
